import React from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

import { PageState } from "@/components/common/PageState";
import { AdminSettingsPage } from "@/components/pages/admin-settings/AdminSettingsPage";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { useLayoutRole } from "@/hooks/useLayoutRole";
import { canAccessAdminSettingsPage } from "@/utils/accessControl";
import { getDefaultAuthorizedRoute } from "@/utils/defaultAuthorizedRoute";

export const SettingsRoutePage = (): React.JSX.Element => {
  const { t } = useTranslation();
  const { userProfile, isLoading } = useAuthenticatedUser();
  const layoutRole = useLayoutRole();

  if (isLoading) {
    return <PageState text={t("common.loading")} />;
  }

  if (userProfile?.role === "SUPER_ADMIN") {
    return <Navigate replace to="/regions" />;
  }

  if (layoutRole === "HOTEL_SCOPED") {
    return <Navigate replace to="/general-info" />;
  }

  if (!canAccessAdminSettingsPage(userProfile)) {
    return <Navigate replace to={getDefaultAuthorizedRoute(userProfile)} />;
  }

  return <AdminSettingsPage />;
};
